import { useState, useEffect } from "react";
import api from "../../../../../features/auth/axiosConfig";
import { Productbtn } from "../../../../../shared/services/interface";

export const useProductData = (categoryID: string, filteredTerm: string) => {
  const [selectedProducts, setSelectedProducts] = useState<Productbtn[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!categoryID) {
      // ✅ If no category selected, clear products and stop loading
      setSelectedProducts([]);
      setLoading(false);
      return;
    }
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const res = await api.get(
          `/app/v1/pos/product?include_deleted=False&pageNumber=&pageSize=&category_id=${categoryID}&searchBy=${filteredTerm}`
        );
        setSelectedProducts(res.data.result || []);
      } catch (error) {
        console.error("Error fetching products:", error);
        setSelectedProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [categoryID, filteredTerm]);

  return { selectedProducts, loading };
};
